module.exports = __webpack_public_path__ + "img/ai-8.b01222f.png";